import { render, staticRenderFns } from "./OnlineReserve.vue?vue&type=template&id=2b611a18&scoped=true"
import script from "./OnlineReserve.vue?vue&type=script&lang=js"
export * from "./OnlineReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b611a18",
  null
  
)

export default component.exports